import script from "./DynamicResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicResultsView.vue?vue&type=script&setup=true&lang=js"

import "./DynamicResultsView.vue?vue&type=style&index=0&id=4661cd81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4661cd81"]])

export default __exports__